module.exports = __webpack_public_path__ + "static/kran04_1920-94ebf7e81595708f504b6e78159b6d5c.jpg";